import { transformParameter, getParameterUnit } from "../../utils/parametersUtil";
import useNormsServiceV2 from "../normsServiceV2";
import { IMeasurementLog, ICareLog, careLogType } from "./types";

export default function useCareLogTransformData(patientUuid: string) {
  const { parameterConfigs } = useNormsServiceV2(patientUuid);

  const transformMeasurementData = (
    measurementItem: IMeasurementLog,
    isImperial: boolean
  ): IMeasurementLog => {
    const { mainParam, mainParamKey, units } = measurementItem;
    return {
      ...measurementItem,
      mainParam: transformParameter(
        parameterConfigs,
        mainParamKey,
        mainParam,
        isImperial
      ),
      units: getParameterUnit(
        parameterConfigs,
        mainParamKey,
        units,
        isImperial
      ),
    };
  };

  const transformCareLogResult = (
    data: { result: ICareLog[] },
    isImperial: boolean,
  ): { result: ICareLog[] } => {
    return {
      ...data,
      result: data.result.map((log) =>
        log.type === careLogType.measurement && log.measurement
          ? {
              ...log,
              measurement: transformMeasurementData(
                log.measurement,
                isImperial
              ),
            }
          : log
      ),
    };
  };

  return { transformCareLogResult };
}
